/**
 * Language Test Constants
 *
 * Shared constants extracted from LanguageTestModal for use by
 * StepIndicator and other sub-components.
 */

export const STEP_LABEL_KEYS = [
  'checkup.languageTests.stepInstructions',
  'checkup.languageTests.stepTakeTest',
  'checkup.languageTests.stepUpload',
  'checkup.languageTests.stepConfirm',
];
